<template>
    <div class="row">
        <div class="col-12">
            <label>{{label}}</label>
        </div>
        <div v-for="option in mappedOptions" :key="option.id" class="col-12">
            <div class="row">
                <div class="col-8">
                    <label v-bind:for="option.id">{{option.text}}</label>
                </div>
                <div class="col-4">
                    <input v-bind:id="option.id"
                           v-bind:value="option.value"
                           v-model="model"
                           type="radio" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {guid} from "../../../../Util/guid";

    export default {
        name: "settings-radio",
        created(){
            const vm = this;

            vm.id = guid();
        },
        data: () => ({
            id: null
        }),
        computed: {
            inputId(){
                const vm = this;

                return `radio-${vm.id}`;
            },
            mappedOptions(){
                const vm = this;
                const optionId = () => `opt_${guid()}`;
                
                if(vm.valueField){
                    const valueField = vm.valueField;
                    const textField = vm.textField || vm.valueField;

                    return vm.options.map(o => ({
                        id: optionId(),
                        
                        value: o[valueField],
                        text: o[textField] 
                    }));
                }

                //Simply use our input options for display/value
                return vm.options.map(o => ({
                    id: optionId(),
                    
                    value: o, 
                    text: o 
                }));
            },
            model: {
                get(){
                    return this.value;
                },
                set(value){
                    this.$emit('input', value);
                }
            }
        },
        props: {
            options: {
                type: Array
            },
            label: {
                type: String,
                required: true
            },
            textField: {
                type: String,
                default: ''
            },
            valueField: {
                type: String,
                default: ''
            },
            value: undefined
        }
    };
</script>
